import { useTheme } from "@react-navigation/native";
import { Button, Divider, useMediaQuery } from "native-base";
import React, { useEffect, useState } from "react";
import { View } from "react-native";
import ContentArea from "../../components/ContentArea";
import ErrorToast from "../../components/ErrorToast";
// Pages.
import Accept from "./Accept";
import MemberRegistration from "./MemberRegistration";

const Wizard = ({ components, navigation }) => {
	const [CurrentStep, setCurrentStep] = useState(1);
	const [Steps, setSteps] = useState([]);
	const [UserDetails, setUserDetails] = useState({});
	const [isFormValid, setIsFormValid] = useState(false);

	const isDesktopOrLaptop = useMediaQuery({ minWidth: 960 });
	const { colors } = useTheme();

	useEffect(() => {
		let StepsArr = [];
		let index = 0;

		if (components?.children_components !== undefined) {
			for (let i = 0; i < components?.children_components.length; i++) {
				index =
					components?.children_components[i].sitepagecomponent_meta[
						"wizard_step"
					];
				if (StepsArr[index] === undefined) {
					StepsArr[index] = [];
				}

				StepsArr[index].push(components?.children_components[i]);
			}
		}

		setSteps(StepsArr);
	}, []);

	const onNext_Click = () => {
		if (isFormValid === false) {
			ErrorToast("Please accept the terms before continuing with registration");
			return;
		}

		if (CurrentStep == 2) {
			return;
		}

		setCurrentStep(CurrentStep + 1);
	};

	const onPrevious_Click = () => {
		if (CurrentStep == 1) return;

		setCurrentStep(CurrentStep - 1);
	};

	return (
		<ContentArea>
			<View
				style={{
					flexDirection: "row",
					padding: 5,
					marginLeft: "auto",
				}}
			>
				<Button
					style={{ margin: 4 }}
					onPress={onPrevious_Click}
					isDisabled={CurrentStep == 1}
					// bgColor={colors.primary}
				>
					Previous
				</Button>
				<Button
					style={{ margin: 4 }}
					onPress={onNext_Click}
					isDisabled={!isFormValid}
					// bgColor={colors.primary}
				>
					{CurrentStep !== 3 ? "Next" : "Finish"}
				</Button>
			</View>
			<Divider style={{ marginVertical: 10 }} />
			{Steps.map((step, index) => {
				if (
					CurrentStep == 1 &&
					step[0].sitepagecomponent_meta.wizard_step == CurrentStep
				) {
					return (
						<Accept
							key={index}
							setIsFormValid={setIsFormValid}
							isFormValid={isFormValid}
						/>
					);
				} else if (
					CurrentStep == 2 &&
					step[0].sitepagecomponent_meta.wizard_step == CurrentStep
				) {
					return (
						<MemberRegistration
							key={index}
							attrs={step}
							setUserDetails={setUserDetails}
							UserDetails={UserDetails}
							setIsFormValid={setIsFormValid}
							navigation={navigation}
						/>
					);
				}
			})}
		</ContentArea>
	);
};

export default Wizard;
